import AdBoardList from './AdBoardList';
import { AD_BOARD } from './adBoard.navigation';

const adBoardRoute = { ...AD_BOARD, component: AdBoardList };

export default adBoardRoute;
